import React from 'react'

import { Divider, Table, Space, Switch, Modal, Button, Select } from 'antd'

import { useCacheVendor, getVendorsForSelect } from '../../../../hooks/cache/vendor'
import { useVendorList, useUpdateTaskVendorModal } from '../../../../hooks/manager/job'

const _filter = (input, option) => option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0

const columns = (props) => [
  {
    title: 'Name',
    dataIndex: 'name',
    filters: vendors(props).map((item) => ({ text: item, value: item })),
    onFilter: (value, record) => record.name.includes(value),
    filterSearch: true
  },
  {
    title: 'Price',
    dataIndex: 'price',
    filters: [{ text: '> 0', value: '>0' }],
    onFilter: (value, record) => (value === '>0' ? record.price != 0 : true)
  },
  {
    title: 'Currency',
    dataIndex: 'currency',
    filters: currencies(props).map((item) => ({ text: item, value: item })),
    onFilter: (value, record) => record.currency.indexOf(value) === 0
  },
  {
    title: 'Score',
    dataIndex: 'score',
    filters: [{ text: '> 0', value: '>0' }],
    onFilter: (value, record) => (value === '>0' ? record.score != 0 : true)
  },
  {
    title: 'Available',
    dataIndex: 'available',
    filters: [
      { text: 'YES', value: 'YES' },
      { text: 'NO', value: 'NO' }
    ],
    onFilter: (value, record) => record.available.indexOf(value) === 0
  },
  {
    title: 'Action',
    dataIndex: 'id',
    render: (id, record) => (
      <Button size='small' type='link' onClick={() => props.handleSubmit(id)}>
        assign
      </Button>
    )
  }
]

const vendors = (props) => {
  const data = props.data?.vendors || []
  const list = []
  data.forEach((item) => {
    list.push(item.name)
  })

  return list
}

const currencies = (props) => {
  const data = props.data?.vendors || []
  const list = []
  data.forEach((item) => {
    if (list.indexOf(item.currency) === -1) {
      list.push(item.currency)
    }
  })

  return list
}

const Formulario = (props) => {
  const { onCancel, taskId, id } = props
  const [tableMode, setTableMode] = React.useState(true)
  const { data, isLoading } = useVendorList(id, taskId)
  const { mutate: updateTaskVendorModal, isLoading: isAssignLoading } = useUpdateTaskVendorModal(id)
  const { data: vendorsRaw, isLoading: isVendorCacheLoading } = useCacheVendor()
  const vendors = getVendorsForSelect(vendorsRaw)

  const loading = isLoading || isVendorCacheLoading

  function handleSubmit (data) {
    const form = {
      taskId,
      form: { vendorId: data }
    }

    updateTaskVendorModal(form, {
      onSuccess: (data) => {
        onCancel()
      },
      onError: () => {
      }
    })
  }

  return (
    <Modal
      title='Assign vendor'
      open
      onOk={handleSubmit}
      confirmLoading={isAssignLoading}
      onCancel={onCancel}
      footer={null}
      width={900}
    >
      <>
        <Space size='small'>
          <Switch checked={tableMode} size='small' onChange={setTableMode} /> Strict Mode
          {!tableMode && (
            <>
              <Divider type='vertical ' />
              Vendor :
              <Select
                placeholder='Vendor'
                allowClear
                size='small'
                showSearch
                options={vendors}
                filterOption={_filter}
                style={{ minWidth: '150px' }}
                onChange={handleSubmit}
              />
            </>
          )}
        </Space>
        {tableMode && (
          <Table
            loading={loading}
            rowKey='id'
            size='small'
            columns={columns({ data, handleSubmit })}
            dataSource={data?.vendors || []}
          />
        )}
      </>
    </Modal>
  )
}

export default Formulario
